import { render, staticRenderFns } from "./UserItemSkeleton.vue?vue&type=template&id=4ac204da"
import script from "./UserItemSkeleton.vue?vue&type=script&lang=js"
export * from "./UserItemSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports